import { render, staticRenderFns } from "./GooglePlayChannelDetail.vue?vue&type=template&id=28a8f139&scoped=true"
import script from "./GooglePlayChannelDetail.vue?vue&type=script&lang=js"
export * from "./GooglePlayChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./GooglePlayChannelDetail.vue?vue&type=style&index=0&id=28a8f139&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a8f139",
  null
  
)

export default component.exports